import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchAffinity } from '../../../../shared/affinity';
import { GlobalState, Thunk } from '../../../types.global';
// import { trackOutbound } from '../../../../shared/analytics/outbound';
import * as actions from './actions';
import { VeveBanner } from './types';

const getBanners = (userId: string) => fetchAffinity(userId, {
  n: '1',
  ist: '1',
  bs: '300x250',
});

type AdTilesResult = { list: VeveBanner[]; savedAt: number };

export const fetchBanners = createAsyncThunk(
  'banners/fetchBanners',
  async (data, thunkAPI): Promise<AdTilesResult> => {
    const state = thunkAPI.getState() as GlobalState;
    const list = await getBanners(state.user.userId) as VeveBanner[];
    return { list, savedAt: Date.now() };
  }
);

export const clickedAd = (): Thunk => (dispatch) => {
  // trackOutbound([
  //   {
  //     variant: 'event',
  //     payload: [
  //       'Clicked_on_an_ad_banner_on_ntp',
  //       {
  //         category: 'Ads',
  //         revenue: 0.2,
  //         provider: 'adMarketplace',
  //       },
  //     ],
  //   },
  //   {
  //     variant: 'revenue',
  //     payload: [
  //       null,
  //       {
  //         productId: 'NTP_AD_BANNER',
  //         category: 'Ads',
  //         quantity: 1,
  //         price: 0.2,
  //       },
  //     ],
  //   },
  // ]);

  dispatch(actions.clickedAd());
};

export const disabledBanner = (value: 'day' | 'forever'): Thunk => (dispatch) => {
  // trackOutbound([
  //   {
  //     variant: 'event',
  //     payload: [
  //       'Disabled_banner_on_ntp',
  //       {
  //         category: 'Banner',
  //         value,
  //       },
  //     ],
  //   },
  // ]);

  const endOfDay = new Date();
  endOfDay.setHours(23, 59, 59, 999);

  dispatch(actions.disabledUntil(value === 'day' ? Number(endOfDay) : -1));
};